import { render, staticRenderFns } from "./LayoutMobile.vue?vue&type=template&id=2d41f949&scoped=true&"
import script from "./LayoutMobile.vue?vue&type=script&lang=js&"
export * from "./LayoutMobile.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMobile.vue?vue&type=style&index=0&id=2d41f949&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d41f949",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
